import { color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-element-action-icon";
const svgIcon = {
  width: "14px",
  height: "14px",
  fill: `${color.black}`
};
const baseIconSmall = {
  width: "28px",
  height: "28px",
  display: "flex",
  color: `${color.black}`,
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.3s",
  "&:hover, &:focus": {
    backgroundColor: `${color.gray.dark}`,
    "& svg, & path": {
      fill: `${color.gray.light}`
    }
  }
};
function composeIcon(options) {
  const { theme = "light" } = options || {};
  let composed = {
    ...baseIconSmall
  };
  if (theme === "light") {
    composed = {
      ...composed,
      backgroundColor: `${color.gray.lightest}`,
      "& svg, & path": {
        ...svgIcon
      }
    };
  } else if (theme === "dark") {
    composed = {
      ...composed,
      backgroundColor: `${color.gray.darker}`,
      color: `${color.white}`,
      "&:hover, &:focus": {
        backgroundColor: `${color.gray.light}`,
        "& svg, & path": {
          fill: `${color.gray.darker}`
        }
      },
      "& svg, & path": {
        ...svgIcon,
        fill: `${color.white}`
      }
    };
  }
  const className = `${classNamePrefix}-button`;
  return objectWithClassName({
    ...composed,
    className
  });
}
const small = composeIcon();
const smallDark = composeIcon({ theme: "dark" });
export {
  composeIcon,
  small,
  smallDark
};
//# sourceMappingURL=icon.js.map
